export default __webpack_public_path__ + "static/media/ic_lock.fa5b2faa.svg";